<template>
  <location-and-tax-settings />
</template>

<script>
import LocationAndTaxSettings from "@/components/3pl/Settings/LocationAndTax/index";
export default {
  components: {
    LocationAndTaxSettings,
  },
};
</script>

<style></style>
